export { default as Input } from './GenericInput';
export * from './GenericInput';
export { default as Label } from './Label/Label.styles';
